import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

export const findAllUserAccessesInProject = (project, formType, id, currentUserId) => {
	const userAccesses = project?.[`${formType.toLowerCase()}Accesses`];
	const result = [];
	if (isNonEmptyArray(userAccesses)) {
		for (let userAccess of userAccesses) {
			if (id === userAccess?.[`${formType.toLowerCase()}Id`] && isNonEmptyArray(userAccess.userIds)) {
				for (let userId of userAccess.userIds) {
					if (userId === currentUserId) {
						result.push(userAccess);
					}
				}
			}
		}
	}

	return result;
};
